const doc = [({"zh_cn":({"constantGenderType":({"man":"男性", "woman":"女士"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;